import React from "react";

export interface FormClientOptions {
	hideDisabledLines?: boolean;
	exitMessage?: string;
}

export const defaultFormClientOptions: FormClientOptions = {};

const FormClientContext = React.createContext<FormClientOptions>(defaultFormClientOptions);

export function FormClientProvider({ options, children }: { options: FormClientOptions; children: React.ReactNode }) {
	const parentOptions = React.useContext(FormClientContext);
	const value = React.useMemo(() => ({ ...parentOptions, ...options }), [parentOptions, options]);

	return <FormClientContext.Provider value={value}>{children}</FormClientContext.Provider>;
}

export function useFormClientOptions() {
	return React.useContext(FormClientContext);
}

export function isFormLineRenderedVisible(isVisible: boolean, isDisabled: boolean, options?: FormClientOptions) {
	if (!isVisible) return false;
	if (options?.hideDisabledLines && isDisabled) return false;
	return true;
}
